import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "../css/Crm.css";
import AnimatedBack from "../images/AnimatedBack.gif";
import Crm1 from "../images/Webd1.png";
import Crm2 from "../images/Webd2.png";
import Crm3 from "../images/Webd3.png";
import Crm4 from "../images/Webd4.png";
import Crm5 from "../images/Webd5.png";
import AnimatedCrm from "../images/AnimatedCrm2.gif";
import Customer from "../components/Customer";

function CRM() {
  return (
    <>
      <Header />
      <div className="Crm">
        {/* Hero Section */}
        <div className="Crm-above">
          <img className="Crm-img" src={AnimatedBack} alt="" />
          <div className="Crm-above-info">
            <p className="Crm-p" >CRM & ERP</p>
            <p className="Crm-p">Development Company</p>
            <p className="Crm-p1">
              Enhance your customer relationships with our tailored CRM
              solutions, designed to streamline interactions and boost
              engagement.
            </p>
          </div>
        </div>

        {/* CRM Services */}
        <div className="Crm-main2 container">
          <p className="Crm-main2-p">CRM & ERP Services</p>
          <p className="Crm-main2-p1">
            Choose from a variety of CRM solutions that are designed for
            specific business requirements.
          </p>

          <div className="Crm-main2-boxes">
            <div className="Crm-main2-box">
              <img className="Crm-main2-img" src={Crm1} alt="" />
              <p>
                Our CRM development services empower organizations and customers
                to connect and share information seamlessly through
                user-friendly tools and an intuitive interface, all while
                ensuring robust security.
              </p>
            </div>
            <div className="Crm-main2-box">
              <img className="Crm-main2-img" src={Crm2} alt="" />
              <p>
                A team of seasoned professionals with extensive expertise in
                designing large-scale CRM applications joined forces to develop
                a robust solution. By leveraging a standardized and agile
                development framework, they ensured the application is
                efficient, scalable, and adaptable to evolving business needs.
              </p>
            </div>
            <div className="Crm-main2-box">
              <img className="Crm-main2-img" src={Crm3} alt="" />
              <p>
                Our dynamic CRM solutions offer tailored modules and seamless
                integration with third-party applications, enabling efficient IT
                synchronization across various platforms to enhance
                functionality and streamline operations.
              </p>
            </div>
            <div className="Crm-main2-box">
              <img className="Crm-main2-img" src={Crm4} alt="" />
              <p>
                We specialize in delivering customized module development
                services for leading CRM platforms such as SugarCRM, Microsoft
                Dynamics, and Vtiger, designed to enhance functionality and
                align with your business goals.
              </p>
            </div>
            <div className="Crm-main2-box">
              <img className="Crm-main2-img" src={Crm5} alt="" />
              <p>
                We provide end-to-end CRM product engineering and software
                upgrade services, ensuring a seamless integration of solutions
                that adapt to your dynamic business requirements and drive
                long-term success.
              </p>
            </div>
          </div>
        </div>

        {/* Why Choose Section */}
        <div className="Webd-main2 container">
          <p className="Webd-main2-p">Why Choose our CRM Solution?</p>
          <p className="Webd-main2-p1">
            We specialize in helping you identify potential clients, generate
            business leads, efficiently manage inventory,
          </p>
          <p className="Webd-main2-p1">
            streamline quotation processing, and set timely reminders for
            important projects.
          </p>

          <div className="Appd-main2-boxes">
            <div className="Appd-main2-box">
              <img className="Crm-main3-img" src={AnimatedCrm} alt="" />
              <p className="Crm-box-title">On Time Completion</p>
              <p>
                We go above and beyond to deliver top-notch CRM solutions
                tailored to your business objectives, ensuring they are
                completed on time and within budget.
              </p>
            </div>
            <div className="Appd-main2-box">
              <img className="Crm-main3-img" src={AnimatedCrm} alt="" />
              <p className="Crm-box-title">Hire on an hourly basis</p>
              <p>
                Our CRM systems are designed to be budget-friendly without
                compromising on quality. Hire skilled CRM developers at an
                affordable rate.
              </p>
            </div>
            <div className="Appd-main2-box">
              <img className="Crm-main3-img" src={AnimatedCrm} alt="" />
              <p className="Crm-box-title">Certified custom CRM developers</p>
              <p>
                Hire CRM Software Developers to enhance your CRM software with a
                range of powerful capabilities and integrations.
              </p>
            </div>
            <div className="Appd-main2-box">
              <img className="Crm-main3-img" src={AnimatedCrm} alt="" />
              <p className="Crm-box-title">24*7 Support</p>
              <p>
                Our CRM development firm offers outstanding customer support
                services with a Customer-First Approach.
              </p>
            </div>
            <div className="Appd-main2-box">
              <img className="Crm-main3-img" src={AnimatedCrm} alt="" />
              <p className="Crm-box-title">Timely reporting</p>
              <p>
                We provide regular updates throughout the entire CRM software
                development process, keeping you informed at every stage.
              </p>
            </div>
            <div className="Appd-main2-box">
              <img className="Crm-main3-img" src={AnimatedCrm} alt="" />
              <p className="Crm-box-title">Flexible hiring options</p>
              <p>
                Our CRM solutions are designed specifically for small businesses
                to manage and nurture B2C relationships with greater efficiency.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Customer />
      <Footer />
    </>
  );
}

export default CRM;
